import { schema } from "normalizr";

const userSchema = new schema.Entity("users");
const artistSchema = new schema.Entity("artists", {}, { idAttribute: "slug" });
const spaceSchema = new schema.Entity("spaces", {}, { idAttribute: "slug" });
const blogSchema = new schema.Entity("blog", {}, { idAttribute: "slug" });
const lessonSchema = new schema.Entity("lessons", {}, { idAttribute: "slug" });
const eventSchema = new schema.Entity("events", {}, { idAttribute: "slug" });
const tickerSchema = new schema.Entity("tickers");
const spaceReservationsSchema = new schema.Entity("spaceReservations", {
    user: userSchema,
    space: spaceSchema,
});

// Schemas for API responses.
export default {
    USER: { data: userSchema },
    USER_ARRAY: { data: [userSchema] },

    ARTIST: { data: artistSchema },
    ARTIST_ARRAY: { data: [artistSchema] },

    SPACE: { data: spaceSchema },
    SPACE_ARRAY: { data: [spaceSchema] },

    BLOG: { data: blogSchema },
    BLOG_ARRAY: { data: [blogSchema] },

    LESSON: { data: lessonSchema },
    LESSON_ARRAY: { data: [lessonSchema] },

    EVENT: { data: eventSchema },
    EVENT_ARRAY: { data: [eventSchema] },

    TICKER_ARRAY: { data: [tickerSchema] },

    SPACE_RESERVATION: { data: spaceReservationsSchema },
    SPACE_RESERVATION_ARRAY: { data: [spaceReservationsSchema] },
};
